import { type DatabaseField, DatabaseFieldType } from '@databases/types/database';
import { formatAiSummaryCsvFieldName } from '@databases/utils/database/csv-field-name';

import { getExperimentValue } from '@canvas/client-feature-flags/experiments';

export function getCsvFieldNames(
  fields: Array<Pick<DatabaseField, 'name' | 'type'>>
): string[] {
  const isAiSummaryEnabled = getExperimentValue(
    'databasesFrontendAiFieldsSummary',
    'enabled',
    { fireExperimentExposure: false }
  );

  return fields.map((field) =>
    isAiSummaryEnabled && field.type === DatabaseFieldType.AI_SUMMARY
      ? formatAiSummaryCsvFieldName(field.name)
      : field.name
  );
}
